import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useIsOwner, useSessionPermission } from '@btime/react-session'
import { useMemo } from 'react'

import { useModalData } from '../../../../../components/modals/ModalsContext'
import { useNavigation } from '../../../../../utils/contexts/NavigationContext'
import { useOpenEditPublicTokenModal } from '../../../../../utils/routes/modals/modalsActions'
import { useRemovePublicTokens } from '../../_requests/remove'

export const useRowsActions = item => {
  const isOwner = useIsOwner()
  const canEdit = useSessionPermission('editPublicToken')
  const canDelete = useSessionPermission('deletePublicToken')

  const navigate = useNavigation()

  const [deleteItems, { loading }] = useRemovePublicTokens()
  const openNewModal = useOpenEditPublicTokenModal()

  const entity = useModalData()

  const singleOptions = useMemo(
    () => [
      ...appendIf(canEdit, {
        value: 'edit',
        icon: 'BsPencil',
        onClick: () => openNewModal({ id: item.id, entity })
      }),

      ...appendIf(canDelete, {
        value: 'remove',
        color: COLORS.lightRed,
        icon: 'BsTrash',
        onClick: () => deleteItems([item.id])
      })
    ],
    [item, navigate]
  )

  return singleOptions
}
